
import dust from "dustjs-linkedin";


(function(){dust.register("copy-link",body_0);function body_0(chk,ctx){return chk.write("<div class=\"referral-link\"><div class=\"icon\">").helper("svg",ctx,{},{"path":"account/link"}).write("</div><input class=\"referral-link\" type=\"url\" value=\"").reference(ctx.get(["link_url"], false),ctx,"h").write("\" /><div class=\"action\"><span class=\"copy\">").helper("i18n",ctx,{},{"id":"account_invite_copy_link_action"}).write("</span><span class=\"copied\">").helper("i18n",ctx,{},{"id":"account_invite_copy_link_action_done"}).write("</span></div></div>");}return body_0;})();

export default 0;
